module.exports = __webpack_public_path__ + "img/lan-left.ff769664.png";